import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import defaultTheme from "../../theme/default";
import { MessagingLayer } from "../../context/messaging-layer";
import { ToastNotifications } from '../../context/toast-notifications';
import { RootContext } from '../../context/root-ref';
import {
  addToast,
  removeToast
} from "../../redux/actions";
import {
} from "../../redux/thunks";
import Toasts from "../toast-notification";
import { cuisineList, dietList, mealList, RECIPES_TOAST_ID, recipesMessages } from './constants';
import showFilterIcon from '../../styles/default/assets/icons/controls-setup-preferences.svg';
import { createRecipeFetcher, createRecipesFetcher } from '../../api/recipes';
import { extractSearchData } from '../../utils/extract-search-data';
import EmptyHeart from '../../styles/default/assets/icons/action-rate-favorite.svg';
import FullHeart from '../../styles/default/assets/icons/action-rate-favorite-full.svg';
import DetailHeart from '../../styles/default/assets/icons/heart.svg';
import EmptyDetailHeart from '../../styles/default/assets/icons/heart-empty.svg';
import { constants } from '../../resource/constants';

const RecipeDetail = ({
  components,
  recipeID,
  onBackHandler,
  showToast,
  inFavoriteList = false,
  setFavorite,
  isAbilityToFavorite,
  apiKey
}) => {
  const [detailsLoading, setDetailsLoading] = useState(true);
  const [recipeDetails, setRecipeDetails] = useState({});
  const [isFavorite, setIsFavorite] = useState(inFavoriteList)
  const formRecipeFetcher = useRef(createRecipeFetcher(recipeID));

  useEffect(() => {
    formRecipeFetcher.current(`api_key=${apiKey}`)
      .then(res => {
        if (res) {
          setRecipeDetails(res);
          setDetailsLoading(false);
        } else {
          showToast("FETCHING_ERROR");
        }
      })
  }, []);

  const handleFavoriteClick = () => {
    setFavorite(recipeDetails, isFavorite);
    setIsFavorite(!isFavorite);
  };

  const drawDetailsInfoPart = (titleName, bodyText) => {
    return (
      <div className="recipe-detail-info-container-web-sdk">
        <components.Text label={titleName} params="recipe-detail-info-header-web-sdk" />
        <components.Text label={bodyText} params="recipe-detail-info-body-web-sdk" />
      </div>
    )
  };

  const drawIngredients = () => {
    let ingredients = [...recipeDetails.Ingredients];
    return ingredients.map(ingredient => {
      return drawDetailsInfoPart(
        ingredient.Name.replace(/^\w/, (c) => c.toUpperCase()),
        `${ingredient.Quantity % 1 === 0 ? ingredient.Quantity : ingredient.Quantity.toFixed(2)} ${ingredient.Unit ? ingredient.Unit : ''}`);
    });
  };

  return (
    <div className="recipe-details-wrapper-web-sdk">
      {detailsLoading ?
        <div><components.Loader /></div>
        :
        <>
          <button
            data-testid="button-back"
            type='button'
            className='button-left-arrow-web-sdk'
            onClick={() => onBackHandler()}
          >
            Back
          </button>

          { recipeDetails.PhotoUrl ? <components.Icon
            showIcon={true}
            src={recipeDetails.PhotoUrl + "?h=480&w=480"}
            stylesObject={{width: '100%', height: '198px', maxWidth: '400px'}}
          /> : null }
          <components.Text label={recipeDetails.Title} params="recipe-detail-title-web-sdk" />
          <div className="recipe-description-wrapper-web-sdk">
            <components.Text label={recipeDetails.Description} params="recipe-detail-description-web-sdk" />

            {isAbilityToFavorite ?
              <components.Icon showIcon={true} src={isFavorite ? DetailHeart : EmptyDetailHeart} onClick={handleFavoriteClick} />
              : null
            }
          </div>
          <div className="recipe-main-info-wrapper-web-sdk">
            {drawDetailsInfoPart("Time", recipeDetails.TotalMinutes + " min")}
            {drawDetailsInfoPart("Ingredients", recipeDetails.Ingredients.length)}
            {drawDetailsInfoPart("Serves", recipeDetails.YieldNumber)}
          </div>
          <components.Text label="Produce" params="recipe-details-section-header-web-sdk" />
          <div className="recipe-ingredients-wrapper-web-sdk" >
            {drawIngredients()}
          </div>
          <components.Text label="Instructions" params="recipe-details-section-header-web-sdk" />
          <div className="recipe-instruction-wrapper-web-sdk">
            <components.Text label={recipeDetails.Instructions} />
          </div>
        </>
      }
    </div>
  )
};

const FindRecipes = ({
  extendedConfiguration: { findRecipes },
  addToast,
  theme = {},
  toasts,
  removeToast,
  screenParams,
}) => {

  const itemsLimitPerPage = 20;
  const recipeListRef = useRef();
  const [recipesData, setRecipesData] = useState([]);
  const [loadingInProgress, setLoadingInProgress] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const [isFiltersCollapsed, setFiltersCollapsed] = useState(true);
  const [recipeDetailsID, setRecipeDetailsID] = useState(null);
  const [showRecipeDetails, setShowRecipeDetails] = useState(false)
  const [favoriteRecipes, setFavoriteRecipes] = useState(findRecipes.favoriteList || []);
  const [inputsValues, setInputsValues] = useState({
    title_kw: "",
    include_primarycat: "",
    any_kw: "",
    cuisine: "",
    pg: 1,
    rpp: 20
  });
  const components = { ...defaultTheme, ...theme };
  const formRecipesFetcher = useRef(createRecipesFetcher());

  let abortController;

  useEffect(() => {
    recipeListRef?.current?.addEventListener('scroll', onScrollHandler);
    return () => {
      recipeListRef?.current?.removeEventListener('scroll', onScrollHandler);
      abortController = window[constants.abortControllerKey];
      if (abortController) {
        abortController.abort();
      }
    }
  });

  const onScrollHandler = () => {
    if (recipeListRef?.current?.scrollTop + recipeListRef?.current?.offsetHeight < recipeListRef?.current?.scrollHeight
      || loadingInProgress) {
      return;
    }
    fetchData(true);
  };

  const drawRecipes = () => {
    let recipes = [...recipesData];
    return recipes.map((recipe, i) => {
      const isFavorite = favoriteRecipes.find(rec => rec.data.id === recipe.RecipeID);
      return (
        <div className="recipe-item-wrapper-web-sdk" onClick={() => getRecipeDetails(recipe.RecipeID)} key={i}>
          { recipe.PhotoUrl ? <components.Icon
            showIcon={true}
            src={recipe.PhotoUrl + "?h=320&w=320"}
            stylesObject={{width: '286px', height: '160px'}}
          /> : null }
          {findRecipes.addToFavorite ? <components.Icon
            showIcon={true}
            src={isFavorite ? FullHeart : EmptyHeart}
            onClick={e => setFavorite(recipe, isFavorite, e)}
            specificClass="favorite-recipe-web-sdk"
          /> : null}
          <components.Text label={recipe.Title} />
        </div>
      )
    })
  };

  const showToast = (messageType = 'NO_RECIPES') => {
    addToast({
      id: RECIPES_TOAST_ID,
      message: recipesMessages[messageType]
    })
  };

  const wrapAddLabel = (text, child, components) => (
    <div className="search-field-wrapper-web-sdk">
      <components.Label text={text} />
      { child }
    </div>
  );

  const fetchData = (useScroll, values) => {
    values = values || inputsValues;
    if (useScroll && isLastPage) {
      return;
    }
    setLoadingInProgress(true);
    !useScroll && setRecipesData([]);

    const pg = useScroll ? values.pg + 1 : values.pg;
    const searchParams = extractSearchData({ ...values, pg});
    formRecipesFetcher.current(searchParams)
      .then(res => {
        if (res) {
          if (res.Results.length) {
            let newRecipesData = [...res.Results];
            useScroll ? setRecipesData([...recipesData, ...newRecipesData]) :
              setRecipesData([...newRecipesData]);
            setLoadingInProgress(false);
            setInputsValues({ ...values, pg});
            (newRecipesData.length < itemsLimitPerPage) && setIsLastPage(true);
          } else {
            setRecipesData([]);
            setLoadingInProgress(false);
            setInputsValues({
              ...values,
              pg: 1
            });
            showToast("NO_RECIPES");
          }
        }
      });
  };

  const onRecipeChange = ({ currentTarget: { value } }, name) => {
    onFieldChange(value, name);
  };

  const onFieldChange = (value, name) => {
    let newInputsValues = {...inputsValues, pg: 1};
    if (newInputsValues[name] !== value) {
      newInputsValues[name] = value;
      setInputsValues(newInputsValues);
      fetchData(false, newInputsValues);
    }
  };

  const onClearFilters = () => {
    setInputsValues({
      title_kw: "",
      include_primarycat: "",
      any_kw: "",
      cuisine: "",
      pg: 1,
      rpp: 20,
      api_key: findRecipes.api_key
    });
    setRecipesData([]);
  };

  const getRecipeDetails = id => {
    if (id) {
      setShowRecipeDetails(true);
      setRecipeDetailsID(id);
    } else {
      setShowRecipeDetails(false);
      setRecipeDetailsID(null);
    }
  };

  const setFavorite = (recipe, isFavorite, event) => {
    if (event) {
      event.stopPropagation();
    }
    findRecipes.addToFavorite({
      favorite: !isFavorite,
      meta: recipe
    });
    let favorRecipes = [...favoriteRecipes]
    if (!isFavorite) {
      favorRecipes.push({data: {id: recipe.RecipeID}});
    } else {
      favorRecipes.splice(favorRecipes.findIndex(rec => rec.data.id === recipe.RecipeID), 1);
    }
    setFavoriteRecipes(favorRecipes);
  };

  return (
    <MessagingLayer
      components={components}
      globalDialogConfig={screenParams.dialogConfig}
    >
      <ToastNotifications components={components}>
        <RootContext.Provider>
          <Toasts
            toasts={toasts}
            onClose={toastId => removeToast(toastId)}
            components={components}
            showToast={showToast}
          />
          <div className="find-recipes-content-web-sdk">
            <components.Title title={`${showRecipeDetails ? "Recipe details" : "Find recipes"}`} />

            {showRecipeDetails ?
              <RecipeDetail
                components={components}
                recipeID={recipeDetailsID}
                onBackHandler={getRecipeDetails}
                inFavoriteList={!!favoriteRecipes.find(item => item.data.id === recipeDetailsID)}
                setFavorite={setFavorite}
                isAbilityToFavorite={!!findRecipes.addToFavorite}
                apiKey={findRecipes.api_key}
              />
              :
              <div className="find-recipes-wrapper-web-sdk">
                <div className="find-recipes-list-content-web-sdk">
                  <div className="expando-header-web-sdk">
                    <span className="clickable" onClick={() => setFiltersCollapsed(!isFiltersCollapsed)}>Find and filter</span>
                    {!isFiltersCollapsed ?
                      <span className="clickable" onClick={() => setFiltersCollapsed(true)}>Collapse</span> :
                      <components.Icon showIcon={true} src={showFilterIcon} onClick={() => setFiltersCollapsed(false)} />
                    }
                  </div>
                  <div className={`find-recipes-web-sdk ${isFiltersCollapsed ? 'collapsed' : ''}`}>
                    <form id='containerForm' className="find-recipes-container-web-sdk">
                      <div className="recipe-input-container-web-sdk">
                        {wrapAddLabel(
                          "Recipe",
                          <components.Input
                            onChange={onRecipeChange}
                            name="title_kw"
                            value={inputsValues.title_kw}
                            placeholder="Please enter recipe"
                          />,
                          components
                        )}
                      </div>
                      <div className="meal-select-container-web-sdk">
                        {wrapAddLabel(
                          "Meal",
                          <components.Select
                            onChange={e => onFieldChange(e, "include_primarycat")}
                            options={mealList}
                            name="include_primarycat"
                            selectedOption={inputsValues.include_primarycat}
                            placeholder="Main dish"
                          />,
                          components
                        )}
                      </div>
                      <div className="diet-select-container-web-sdk">
                        {wrapAddLabel(
                          "Diet",
                          <components.Select
                            onChange={e => onFieldChange(e, "any_kw")}
                            options={dietList}
                            name="any_kw"
                            selectedOption={inputsValues.any_kw}
                            placeholder="Any diet"
                          />,
                          components
                        )}
                      </div>
                      <div className="cuisine-select-container-web-sdk">
                        {wrapAddLabel(
                          "Cuisine",
                          <components.Select
                            onChange={e => onFieldChange(e, "cuisine")}
                            options={cuisineList}
                            name="cuisine"
                            selectedOption={inputsValues.cuisine}
                            placeholder="Any cuisine"
                          />,
                          components
                        )}
                      </div>
                      <components.Text label="Clear filters" onClick={onClearFilters} params="clear-filters-web-sdk" />
                    </form>
                  </div>
                </div>
                {recipesData.length ?
                  <div className="recipes-search-results-web-sdk">
                    <div ref={recipeListRef} className="recipes-list-web-sdk">
                      {drawRecipes()}
                    </div>
                  </div>
                  : null
                }
              </div>
            }

            {loadingInProgress && <div><components.Loader /></div>}
          </div>
        </RootContext.Provider>
      </ToastNotifications>
    </MessagingLayer>
  );
}

FindRecipes.propTypes = {
  addToast:            PropTypes.func.isRequired,
  removeToast:         PropTypes.func.isRequired,
  fieldConfigurations: PropTypes.object,
  toasts:              PropTypes.array,
  theme:               PropTypes.object
};

export default connect(
  ({ tdFlow }) => ({
    toasts:       tdFlow.toasts,
    screenParams: tdFlow.screenParams
  }),
  {
    addToast,
    removeToast
  }
)(FindRecipes);
